import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
// import PartnerSearch from "./PartnerSearch";
import ApplicationsTable from "./ApplicationsTable";
import DownloadExcel from "../../extraComponents/DownloadExcel";
import PartnerSearch from "../../Partner/PartnerSearch";
import { allLeadApplicationFilterAction, allLeadApplicationFindWithoutPaginationAction, findAllLeadApplicationAction } from "../../../actions/aplicationActions/applicationsAction";
import {
  Alert,
  AlertTitle,
  Grid,
  Pagination,
  TablePagination
} from "@mui/material";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";
import LeadsFilterSearch from "../../Leads/LeadsFilterSearch";
import DownloadPdf from "../../extraComponents/DownloadPdf";
import axios from "axios";

// material Table
const columns = [
  {
    title: "Sl no",
    field: "sl"
  },
  {
    title: "Student name",
    field: "studentName",
    hidden: false
  },
  {
    title: "Passport Number",
    field: "passportNumber",
    hidden: false
  },
  {
    title: "Email",
    field: "Email",
    hidden: false
  },
  {
    title: "Phone Number",
    field: "Phone Number",
    hidden: false
  },
  {
    title: "Country",
    field: "country",
    hidden: false
  },
  {
    title: "Course",
    field: "course",
    hidden: false
  },
  {
    title: "University",
    field: "University",
    hidden: false
  },

  {
    title: "University Handler",
    field: "universityHandler",
    hidden: false
  },
  {
    title: "Lead owner",
    field: "leadOwner",
    hidden: false
  },
  {
    title: "Counsilor",
    field: "counsilor",
    hidden: false
  },
  {
    title: "Telecaller",
    field: "Telecaller",
    hidden: false
  },
  {
    title: "Intake",
    field: "intakes",
    hidden: false
  },
  {
    title: "Application Started Date",
    field: "Application Started Date",
    hidden: false
  },
  {
    title: "status",
    field: "statuss",
    hidden: false
  },
  {
    title: "Deferal intake month",
    field: "deferralMonth",
    hidden: false
  },
  {
    title: "Deferal intake year",
    field: "deferalYear",
    hidden: false
  },

  {
    title: "Payment status",
    field: "Paymentstatus",
    hidden: false
  },
  {
    title: "Action",
    field: "action",
    filtering: false
  }
];

function AllLeadApplications() {
  const dispatch = useDispatch();
  const { privilege, hasPrivilege } = usePrivilegeCheck();

  const [data, setData] = useState([]);
  // const [applicationData, setApplicationData] = useState([]);
  const [applicationData, setApplicationData] = useState([]);
  const [filterPassData, setFilterPassData] = useState();
  // const [columnName, setColumnName] = useState("");
  const [whichFilter, setwhichFilter] = useState();
  const [reset, setReset] = useState(false);
  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [leadId, setLeadId] = useState([]);
  const [ids, setIds] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pagiantionEntry, setPagiantionEntry] = useState(25);
  // / Employee column Visibility
  const [showNameColumn, setShowNameColumn] = useState(false);
  const [showEmailColumn, setShowEmailColumn] = useState(false);
  const [showPhoneColumn, setShowPhoneColumn] = useState(false);
  const [showWhatsAppNumColumn, setShowWhatsAppNumColumn] = useState(false);
  const [showPrefferedColumn, setShowPrefferedColumn] = useState(false);
  const [showLeadSourceColumn, setShowLeadSourceColumn] = useState(false);
  const [showLeadTypeColumn, setShowLeadTypeColumn] = useState(false);
  const [showStatusColumn, setShowStatusColumn] = useState(false);
  const [showEducationColumn, setShowEducationColumn] = useState(false);
  const [showUniversityPlaceColumn, setShowUniversityPlaceColumn] = useState(false);
  const [viewedColumn, setViewedColumn] = useState([])
  const [columnVisibilityData, setColumnVisibilityData] = useState([])
  const [searchPagination, setSearchPagination] = useState(false)
  const [filterPagination, setFilterPagination] = useState(false)
  const [searchValue, setSearchValue] = useState('');
  const [searchPaginationCount, setSearchPaginationCount] = useState(0)
  const [searchPaginationRows, setSearchPaginationRows] = useState(0)
  const [currentFilterData, setCurrentFilterData] = useState(null);
  

  let { applicationAllFindSuccess } = useSelector((state) => {
    return state.findAllLeadApplication;
  });  
  
  const { allLeadFindWithoutPaginationSuccess } = useSelector((state) => state.findAllLeadApplicationWithoutPagination)
  
  const { allLeadApplicationFilterSuccess } = useSelector((state) => state.allLeadApplicationFilter)
  
  useEffect(() => {
    if (applicationAllFindSuccess) {
      setData(applicationAllFindSuccess?.data);
      setApplicationData(
        applicationAllFindSuccess?.data?.map((item) => ({
          id: item.id,
          column1: item.lead?.firstName,
          passport: item.lead?.lead_personal_details?.[0]?.passportNumber,
          email: item.lead?.email,
          mobile: item.lead?.mobileNumber,
          column2: item?.universityCountry,
          column3: item?.courseName,
          column4: item?.universityName,
          column5: item?.user !== null ? item?.user?.firstName : "Not Assigned",
          column6: item?.lead?.leadOwnerName,
          column7: item?.lead?.Counselor?.firstName,
          column8:
            item?.lead?.Telecaller?.firstName !== undefined
              ? item?.lead?.Telecaller?.firstName
              : " ",
          column9: item?.intakeDate === null ? " " : item?.intakeDate,
          column10: item?.methodStatus === null ? " " : item?.methodStatus,
          column11:
            item?.lead?.deferalIntakeMonth === null
              ? " "
              : item?.lead?.deferalIntakeMonth,
          column12:
            item?.lead?.deferalIntakeYear === null
              ? " "
              : item?.lead?.deferalIntakeYear,
          column13: item?.paymentStatus === null ? " " : item?.paymentStatus,
          column14:
            item?.createdAt === null || undefined
              ? " "
              : item?.createdAt?.split("T")[0],
          leadId: item?.leadId
        }))
      )
    }
  }, [applicationAllFindSuccess]);

  useEffect(() => {
    if (allLeadApplicationFilterSuccess) {
      setFilterPagination(true);
      // setPaginationPageNumber(1);
      setData(allLeadApplicationFilterSuccess?.data);
      setApplicationData(
        allLeadApplicationFilterSuccess?.data?.map((item) => ({
          id: item.id,
          column1: item.lead?.firstName,
          passport: item.lead?.lead_personal_details?.[0]?.passportNumber,
          email: item.lead?.email,
          mobile: item.lead?.mobileNumber,
          column2: item?.universityCountry,
          column3: item?.courseName,
          column4: item?.universityName,
          column5: item?.user !== null ? item?.user?.firstName : "Not Assigned",
          column6: item?.lead?.leadOwnerName,
          column7: item?.lead?.Counselor?.firstName,
          column8:
            item?.lead?.Telecaller?.firstName !== undefined
              ? item?.lead?.Telecaller?.firstName
              : " ",
          column9: item?.intakeDate === null ? " " : item?.intakeDate,
          column10: item?.methodStatus === null ? " " : item?.methodStatus,
          column11:
            item?.lead?.deferalIntakeMonth === null
              ? " "
              : item?.lead?.deferalIntakeMonth,
          column12:
            item?.lead?.deferalIntakeYear === null
              ? " "
              : item?.lead?.deferalIntakeYear,
          column13: item?.paymentStatus === null ? " " : item?.paymentStatus,
          column14:
            item?.createdAt === null || undefined
              ? " "
              : item?.createdAt?.split("T")[0],
          leadId: item?.leadId
        }))
      );
    }
  }, [allLeadApplicationFilterSuccess]);

  useEffect(() => {
    if (!searchPagination && !filterPagination) {
      dispatch(findAllLeadApplicationAction(pagiantionEntry, page, "allApplication"));
      dispatch(allLeadApplicationFindWithoutPaginationAction("allApplication"))
    }
  }, [
    dispatch,
    pagiantionEntry,
    page,
    searchPagination,
    filterPagination
  ])

  useEffect(() => {
    const columnVisibilityData = columns.filter((col) => {
      if (viewedColumn.includes(col.field)) {
        return col
      }
    })
    setColumnVisibilityData(columnVisibilityData)
  }, [viewedColumn])

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  //   setPaginationPageNumber(newPage)
  // };

  const handleChangePage = (event, pageNumber) => {
    try {
      setPaginationPageNumber(pageNumber);
      setPage(pageNumber);

      if (searchPagination && searchValue) {
        fetchSearchResult(searchValue, pageNumber);
      } else if (filterPagination && currentFilterData) {
        dispatch(allLeadApplicationFilterAction(currentFilterData, pagiantionEntry, pageNumber));
      } else {
        dispatch(findAllLeadApplicationAction(pagiantionEntry, pageNumber));
      }
    } catch (error) {
      console.error(error);
    }
  };

  // const handleChangeRowsPerPage = (event) => {
  //   alert(event.target.value);
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   // setPage(1);
  // };

  const toggleNameColumn = (status, columnName) => {    
    setViewedColumn((prevColumns) => {
      if (status) {
        return prevColumns.includes(columnName) ? prevColumns : [...prevColumns, columnName];
      } else {
        return prevColumns.filter((col) => col !== columnName);
      }
    });
  };

  // excel download
  const excelDownloadClick = () => {
    const filterColumns = columns.filter((item) => item.field !== "action");
    DownloadExcel(filterColumns, data, "Allapplication_Management");
  };

  const pdfDownloadClick = () => {
    const filterColumns = columns.filter((item) => item.field !== "action");

    DownloadPdf(
      filterColumns,
      data,
      "Allapplication_Management",
      "All Applications"
    );
  };

  const handleSearchChange = (e) => {
    try {
      const newValue = e.target.value.trim()
      setSearchValue(newValue);

      if(newValue === "") {
        setSearchPagination(false);
        dispatch(findAllLeadApplicationAction(pagiantionEntry, page, "allApplication"))
        return 
      }

      setPaginationPageNumber(1);
    } catch(error) {
      console.error(error);
    }
  }

  const searchHandleChange = (e) => {
    try {
      const newValue = e.target.value.trim()

      if (newValue === "") {
        setSearchPagination(false);
        dispatch(findAllLeadApplicationAction(pagiantionEntry, page, "allApplication"))
        return
      }

      setSearchValue(newValue);
      setSearchPagination(true);
      setFilterPagination(false);

      fetchSearchResult(newValue, page, "allApplication")
    } catch (error) {
      console.error(error);
    }
  }

  const fetchSearchResult = async (searchValue, pageNumber, tabSection) => {
    try {
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let UserId = isUserExist?.UserId;

      let { data } = await axios.get(
        `/api/admin/application/findAllApplicationSearch?q=${searchValue}&id=${UserId}&limit=${pagiantionEntry}&pageCount=${pageNumber}&tabSection=${tabSection}`,
        config
      )
      
      setSearchPaginationCount(data?.totalPages);
      setSearchPaginationRows(data?.currentPage)
      setData(data?.data);
      setApplicationData(
        data?.data?.map((item) => ({
          id: item.id,
          column1: item?.leadFirstName,
          passport: item?.passportNumber,
          email: item?.leadEmail,
          mobile: item?.leadMobileNumber,
          column2: item?.universityCountry,
          column3: item?.courseName,
          column4: item?.universityName,
          column5: item?.handlerFirstName !== null ? item?.handlerFirstName : "Not Assigned",
          column6: item?.branchManager,
          column7: item?.counselorFirstName,
          column8:
            item?.telecallerFirstName !== null
              ? item?.telecallerFirstName
              : " ",
          column9: item?.intakeDate === null ? " " : item?.intakeDate,
          column10: item?.methodStatus === null ? " " : item?.methodStatus,
          column11:
            item?.deferralMonth=== null
              ? " "
              : item?.deferralMonth,
          column12:
            item?.deferalYear === null
              ? " "
              : item?.deferalYear,
          column13: item?.paymentStatus === null ? " " : item?.paymentStatus,
          column14:
            item?.createdAt === null || undefined
              ? " "
              : item?.createdAt?.split("T")[0],
          leadId: item?.leadId
        }))
      );

    } catch (error) {
      console.error(error);
    }
  }

  // cleare filter
  const handleResetData = (status) => {
    setwhichFilter(null);
    setFilterPassData(null);
    setReset(!reset);
    setwhichFilter(null);
    setFilterPassData(null);
    setPaginationPageNumber(1);
    setApplicationData(
      applicationAllFindSuccess?.data?.map((item) => ({
        id: item.id,
        column1: item.lead?.firstName,
        passport: item.lead?.lead_personal_details?.[0]?.passportNumber,
        email: item.lead?.email,
        mobile: item.lead?.mobileNumber,
        column2: item?.universityCountry,
        column3: item?.courseName,
        column4: item?.universityName,
        column5: item?.user !== null ? item?.user?.firstName : "Not Assigned",
        column6: item?.lead?.leadOwnerName,
        column7: item?.lead?.Counselor?.firstName,
        column8: item?.lead?.Telecaller?.firstName,
        column9: item.intakeDate,
        column10: item.methodStatus,
        column11: item?.lead?.deferalIntakeMonth,
        column12: item?.lead?.deferalIntakeYear,
        column13: item?.paymentStatus,
        column14: item?.createdAt?.split("T")[0],
        leadId: item?.leadId
      }))
    );
    setSearchPagination(false);
    setFilterPagination(false);
    setSearchValue('');
    setCurrentFilterData(null);
    dispatch(findAllLeadApplicationAction(pagiantionEntry, 1));
  };

  const handleDeleteClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        // dispatch(deleteLeadAction(leadId));
      }
    });
  };

  if (!hasPrivilege("all application") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  const handlePaginationEntry = (e) => {
    let value = e.target.value;
    setPagiantionEntry(value);

    setPaginationPageNumber(1);

    if (searchPagination && searchValue) {
      fetchSearchResult(searchValue, 1);
    } else if (filterPagination && currentFilterData) {
      dispatch(allLeadApplicationFilterAction(currentFilterData, value, 1));
    } else {
      dispatch(findAllLeadApplicationAction(value, 1));
    }
  }

  const LeadFilterFunction = (filterData) => {
    try {
      setCurrentFilterData(filterData);
      setSearchPagination(false);
      setFilterPagination(true);
      setPaginationPageNumber(1);
      dispatch(allLeadApplicationFilterAction(filterData, pagiantionEntry, 1, "allApplication"))      
    } catch(error) {
      console.error(error);
    }
  }

  return (
    <>
      <PartnerSearch
        columnVisibleHandler={toggleNameColumn}
        excelDownloadClick={excelDownloadClick}
        pdfDownloadClick={pdfDownloadClick}
        showNameColumn={showNameColumn}
        showEmailColumn={showEmailColumn}
        showPrefferedColumn={showPrefferedColumn}
        showPhoneColumn={showPhoneColumn}
        showWhatsAppNumColumn={showWhatsAppNumColumn}
        showLeadSourceColumn={showLeadSourceColumn}
        showLeadTypeColumn={showLeadTypeColumn}
        showStatusColumn={showStatusColumn}
        showEducationColumn={showEducationColumn}
        showUniversityPlaceColumn={showUniversityPlaceColumn}
        filterPassData={filterPassData ? filterPassData : null}
        whichFilter={whichFilter ? whichFilter : null}
        handleResetData={handleResetData}
        handleDeleteClick={handleDeleteClick}
        searchHandleChange={searchHandleChange}
        ids={ids}
        leadId={leadId}
        component="application"
        noAction={true}
        column={columns}
        viewedColumn={viewedColumn}
        handleSearchChange={handleSearchChange}
      />
      <Grid container spacing={-3} sx={{ mt: "-31px"}}>
        <Grid item xs={12} md={2} lg={2.2}>
          <LeadsFilterSearch
            LeadFilterFunction={LeadFilterFunction}
            handleResetData={handleResetData}
            statusComponent="leadApplication"
            component="application"
            data={allLeadFindWithoutPaginationSuccess?.data}
            pagiantionEntry={pagiantionEntry}
            handlePaginationEntry={handlePaginationEntry}
          />
        </Grid>
        <Grid item xs={12} md={10} lg={9.8} sx={{ paddingLeft: "30px" }}>
          <ApplicationsTable
            columns={columnVisibilityData.length > 0 ? columnVisibilityData : columns}
            data={applicationData}
            component="application"
            subMenu="all application"
            mainMenu="Application"
            pagiantionEntry={pagiantionEntry}
            paginationPageNumber={paginationPageNumber}
            viewedColumn={viewedColumn}
          />
        </Grid>
      </Grid>

      {/* <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]} // Customize the rows per page options as needed
        component="div"
        count={applicationData.length} // Total number of rows
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}

      <Pagination
        sx={{
          mt: "28px",
          "& .Mui-selected": {
            backgroundColor: "#f81b82 !important",
            color: "#fff"
          },
          "& .MuiPagination-ul": {
            justifyContent: "end"
          }
        }}
        rowsPerPageOptions={[10, 25, 50, 100]} // Customize the rows per page options as needed
        component="div"
        // count={applicationAllFindSuccess?.totalPages}
        count={
          searchPagination ? searchPaginationCount :
            filterPagination ? allLeadApplicationFilterSuccess?.totalPages :
              applicationAllFindSuccess?.totalPages
        }
        rowsPerPage={applicationAllFindSuccess?.currentPage}
        // rowsPerPage={
        //   searchPagination ? searchPaginationRows :
        //     filterPagination ? allLeadApplicationFilterSuccess?.currentPage :
        //       applicationAllFindSuccess?.currentPage
        // }
        page={page}
        onChange={handleChangePage}
        // onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}

export default AllLeadApplications;
